import { getters } from '/@/modules/core/app/helpers/store';
import { PaidPlanRouteConfig } from '@/modules/core/app/helpers/PaidPlanRouteConfig';

export class OverviewRouteConfig extends PaidPlanRouteConfig {
  /**
   * @returns {boolean}
   */
  canAccessRoute() {
    const user = getters.auth.getUser();

    if (user?.currentEstate.isClearWill) {
      return user.permission.canAccessClearWillEstateAccountingPage;
    }

    return super.canAccessRoute();
  }
}
